import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FilterItem, FilterType, ForceDirection, InputType, PagingOptions, TextAreaOptions, TextBoxOptions } from 'bbsf-controls';
import { DataSecretService } from '../../shared/Services/data.service';
import { WFCreationModel } from '../../shared/models/WorkflowModels/WFCreationModel';
import { WorkflowService } from '../../shared/Services/WorkflowService.service';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bbsf-utilities';

@Component({
  selector: 'lib-workflow',
  templateUrl: './workflow.component.html'
})
export class WorkflowComponent implements OnInit {

  ApiUrl = "/api/admin/Workflow/"

  searchTextBox: TextBoxOptions;
  WorkflowForm = new FormGroup({});
  showFilter: boolean = false;
  WorkflowPagingResult: any[] = [];
  WorkflowPaging: PagingOptions;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean;
  @ViewChild('WorkflowPagingViewElement', { static: false }) input: ElementRef;


  //Add Model Controls
  AddWorkflowForm = new FormGroup({});
  NameInEnglish: TextBoxOptions;
  NameInArabic: TextBoxOptions;
  SysName: TextBoxOptions;
  DescriptionInEnglish: TextAreaOptions;
  DescriptionInArabic: TextAreaOptions;
  @ViewChild('CloseWorkflowModal', { static: false }) CloseWorkflowModal: ElementRef;

  //Edit Model Controls
  EditWorkflowForm = new FormGroup({});
  EditNameInEnglish: TextBoxOptions;
  EditNameInArabic: TextBoxOptions;
  EditSysName: TextBoxOptions;
  EditDescriptionInEnglish: TextAreaOptions;
  EditDescriptionInArabic: TextAreaOptions;
  WorkflowId: number;
  @ViewChild('CloseEditWorkflowModal', { static: false }) CloseEditWorkflowModal: ElementRef;

  language:string=""
  // Decorator wires up blockUI instance
  ShowPageContent:boolean=false;

  constructor(private dataServices: DataSecretService, private authService: AuthService, private WorkflowService: WorkflowService, private modalService: NgbModal,public utilityService:UtilityService,private environmentService:EnvironmentService,private bbsfTranslateService:BBSFTranslateService,private pageInfoService:PageInfoService) {
  }

  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("Workflows")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadList();
  }

 
  LoadList() {
      // TextBox inti
      this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.HideLabel = true;
      this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")

      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.WorkflowPaging = new PagingOptions();
      this.WorkflowPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetWorkflowByFilter';
      this.WorkflowPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.WorkflowPaging.Filters = [this.TextInputFilter]
      this.WorkflowPaging.ValidationToken = this.authService.authorizationHeaderValue()
      this.IsFilterLoaded = true;
       
  }

  ReinitializeGetWorkflowPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateWorkflowPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setWorkflowListResult(result) {
    this.WorkflowPagingResult= result
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI();
  }

  resetFilters() {
    this.WorkflowForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  showAddWorkflowModal(AddWorkflowModal) {
    this.utilityService.startBlockUI();
    this.AddWorkflowForm = new FormGroup({})

    this.NameInEnglish = new TextBoxOptions();
    this.NameInEnglish.Name = "NameInEnglish";
    this.NameInEnglish.LabelKey = "NameInEnglish";
    this.NameInEnglish.Type = InputType.Text;
    this.NameInEnglish.IsRequired = true;
    this.NameInEnglish.Value = null;


    this.NameInArabic = new TextBoxOptions();
    this.NameInArabic.Name = "NameInArabic";
    this.NameInArabic.LabelKey = "NameInArabic";
    this.NameInArabic.Type = InputType.Text;
    this.NameInArabic.Value = null;
    this.NameInArabic.IsRequired = true;
    this.NameInArabic.ForceDirection = ForceDirection.Arabic;

    this.SysName = new TextBoxOptions();
    this.SysName.Name = "SysName";
    this.SysName.LabelKey = "SysName";
    this.SysName.Type = InputType.Text;
    this.SysName.Value = null;
    this.SysName.IsRequired = true;


    this.DescriptionInEnglish = new TextAreaOptions();
    this.DescriptionInEnglish.Name = "DescriptionInEnglish";
    this.DescriptionInEnglish.LabelKey = "DescriptionInEnglish";
    this.DescriptionInEnglish.Value = null;


    this.DescriptionInArabic = new TextAreaOptions();
    this.DescriptionInArabic.Name = "DescriptionInArabic";
    this.DescriptionInArabic.LabelKey = "DescriptionInArabic";
    this.DescriptionInArabic.Value = null;
    this.DescriptionInArabic.ForceDirection = ForceDirection.Arabic;
    this.modalService.open(AddWorkflowModal);
    this.utilityService.stopBlockUI();
  }

  addWorkflow() {
    if (this.AddWorkflowForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddWorkflowForm.value;
      let AddModel:WFCreationModel= new WFCreationModel() ;
      AddModel.Name.English = ResultModel.NameInEnglish
      AddModel.Name.Arabic = ResultModel.NameInArabic
      AddModel.SysName = ResultModel.SysName
      AddModel.Description.English = ResultModel.DescriptionInEnglish
      AddModel.Description.Arabic = ResultModel.DescriptionInArabic
      this.WorkflowService.AddWorkflow(AddModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
      })
    }
  }


  showEditWorkflowModal(Workflow: any, EditWorkflowModal) {

    this.utilityService.startBlockUI();
    this.EditWorkflowForm = new FormGroup({})

    this.EditNameInEnglish = new TextBoxOptions();
    this.EditNameInEnglish.Name = "EditNameInEnglish";
    this.EditNameInEnglish.LabelKey = "NameInEnglish";
    this.EditNameInEnglish.Type = InputType.Text;
    this.EditNameInEnglish.IsRequired = true;
    this.EditNameInEnglish.Value = Workflow.name.english;


    this.WorkflowId = Workflow.id

    this.EditNameInArabic = new TextBoxOptions();
    this.EditNameInArabic.Name = "EditNameInArabic";
    this.EditNameInArabic.LabelKey = "NameInArabic";
    this.EditNameInArabic.Type = InputType.Text;
    this.EditNameInArabic.Value =Workflow.name.arabic;
    this.EditNameInArabic.IsRequired = true;
    this.EditNameInArabic.ForceDirection = ForceDirection.Arabic;

    this.EditSysName = new TextBoxOptions();
    this.EditSysName.Name = "EditSysName";
    this.EditSysName.LabelKey = "SysName";
    this.EditSysName.Type = InputType.Text;
    this.EditSysName.Value = Workflow.sysName;
    this.EditSysName.IsRequired = true;



    this.EditDescriptionInEnglish = new TextAreaOptions();
    this.EditDescriptionInEnglish.Name = "EditDescriptionInEnglish";
    this.EditDescriptionInEnglish.LabelKey = "DescriptionInEnglish";
    this.EditDescriptionInEnglish.Value = Workflow.description.english;


    this.EditDescriptionInArabic = new TextAreaOptions();
    this.EditDescriptionInArabic.Name = "EditDescriptionInArabic";
    this.EditDescriptionInArabic.LabelKey = "DescriptionInArabic";
    this.EditDescriptionInArabic.Value = Workflow.description.arabic;
    this.EditDescriptionInArabic.ForceDirection = ForceDirection.Arabic;
    this.modalService.open(EditWorkflowModal);
    this.utilityService.stopBlockUI();

  }

  editWorkflow() {
    if (this.EditWorkflowForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditWorkflowForm.value;
      let EditModel:WFCreationModel= new WFCreationModel() ;
      EditModel.Id=this.WorkflowId;
      EditModel.Name.English = ResultModel.EditNameInEnglish
      EditModel.Name.Arabic = ResultModel.EditNameInArabic
      EditModel.SysName = ResultModel.EditSysName
      EditModel.Description.English = ResultModel.EditDescriptionInEnglish
      EditModel.Description.Arabic = ResultModel.EditDescriptionInArabic

      this.WorkflowService.EditWorkflow(EditModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
       
      })
    }
  }

 


}
